/**
 * Assessment enums, re-exported from `@brighterly/lib-core-types` — nothing is redeclared locally.
 * `Grade` carries the `K` (Kindergarten) and `K1`…`K12` values the assessment-template `grade`
 * field accepts.
 */
export { AssessmentType } from '@brighterly/lib-core-types/student-assessment/enums'
export { Grade } from '@brighterly/lib-core-types/kid/enums'

/**
 * The template lifecycle (RND-76). Mirrors `App\Enums\Assessment\AssessmentTemplateStatus` in
 * `base-main-app` — wire values, never renamed independently. Local because lib-core-types has no
 * template-side enum (its `AssessmentStatus` is the kid's ATTEMPT status, a different thing).
 *
 * Only `PUBLISHED` templates are offered to tutors; a new template and every duplicate start as
 * `DRAFT`.
 */
export enum AssessmentTemplateStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}
